export default __webpack_public_path__ + "static/media/warning.1a3772dd.svg";